import React from 'react';
import PropTypes from 'prop-types';
import styles from './Image.module.css';

const ImageGroup = ({ children, className }) => {
  return (
    <div className={`${styles['image-group']} ${className || ''}`}>
      {children}
    </div>
  );
};

ImageGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ImageGroup;
